const transactionAdvisoryCareers = [

    {
        id: 27,
        slug: "transaction-advisory-junior-research-analyst",
        title: "Junior Research Analyst (JRA)",
        department: "Investment & Transaction Advisory",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Support data collection for transactions and investment projects",
                "Assist in preparing company profiles and industry overviews",
                "Compile financial and operational data for analysis",
                "Support preparation of presentations and reports",
                "Maintain research files and project documentation"
            ],
            skills: [
                "Basic financial and business research skills",
                "Excel and PowerPoint fundamentals",
                "Attention to detail",
                "Ability to organize financial and market data"
            ],
            experience: ["Fresher"],
            education: ["Bachelor’s degree in Finance, Economics, Business, or Commerce"]
        }
    },

    {
        id: 28,
        slug: "research-analyst",
        title: "Research Analyst (RA)",
        department: "Investment & Transaction Advisory",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Conduct company and industry analysis for transactions",
                "Assist in preparing financial models and valuation analysis",
                "Support preparation of pitch decks and investment materials",
                "Assist in due diligence and transaction research",
                "Prepare research summaries and financial analysis"
            ],
            skills: [
                "Financial analysis fundamentals",
                "Excel and PowerPoint proficiency",
                "Understanding of valuation concepts",
                "Analytical thinking"
            ],
            experience: ["0–1 years"],
            education: [
                "Bachelor’s degree in Finance, Economics, Business, or Commerce",
                "MBA Finance / CFA Level I preferred"
            ]
        }
    },

    {
        id: 29,
        slug: "senior-research-analyst",
        title: "Senior Research Analyst (SRA)",
        department: "Investment & Transaction Advisory",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Build financial models and valuation analysis",
                "Prepare investment analysis and transaction reports",
                "Support due diligence and deal evaluation",
                "Analyze company financial performance and market positioning",
                "Support preparation of investment memos and presentations"
            ],
            skills: [
                "Financial modeling and valuation",
                "Financial statement analysis",
                "Transaction research",
                "Strong analytical capability"
            ],
            experience: ["1–3 years"],
            education: [
                "Bachelor’s or Master’s degree in Finance, Economics, or Business",
                "MBA Finance / CFA preferred"
            ]
        }
    },

    {
        id: 30,
        slug: "associate",
        title: "Associate",
        department: "Investment & Transaction Advisory",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Support transaction execution and deal analysis",
                "Prepare financial models, valuation work, and investment analysis",
                "Assist in due diligence and transaction documentation",
                "Support preparation of pitch books and investment materials",
                "Coordinate work between analysts and senior team members"
            ],
            skills: [
                "Financial modeling and valuation",
                "Transaction analysis",
                "Structured problem solving",
                "Communication and coordination"
            ],
            experience: ["3+ years"],
            education: [
                "Bachelor’s or Master’s degree in Finance, Economics, or Business",
                "MBA Finance / CFA preferred"
            ]
        }
    },

    {
        id: 31,
        slug: "senior-associate",
        title: "Senior Associate",
        department: "Investment & Transaction Advisory",
        location: "Remote",
        datePosted: "2026-04-13",
        employmentType: "FULL_TIME",
        applicantCountry: "IN",
        description: {
            responsibilities: [
                "Lead financial analysis and modeling for transactions",
                "Review valuation models and investment analysis",
                "Support transaction structuring and due diligence",
                "Prepare investment memos and client presentations",
                "Guide analysts and associates on project work"
            ],
            skills: [
                "Advanced financial modeling",
                "Valuation and transaction analysis",
                "Analytical thinking",
                "Project coordination"
            ],
            experience: ["5+ years"],
            education: [
                "Bachelor’s or Master’s degree in Finance, Economics, or Business",
                "MBA Finance / CFA preferred"
            ]
        }
    }
];

export default transactionAdvisoryCareers;
